import { useState, useEffect, useCallback } from "react";
import { FaSearch } from 'react-icons/fa';
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import DataTable from 'react-data-table-component';
import '../common/style.css';
import './sarfaesi.css';
import { useLocation, useNavigate } from 'react-router-dom';
import {  showAccountByBankID } from "../http/api";
import Loading from "../loading/loading";
import { useAuth } from "../http/authcontex";
import { Toast } from 'react-bootstrap';
import { MdPayment } from "react-icons/md";

export default function ShowSarfaesiAyAdmin() {
    const [bankName, setBankName] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authContext = useAuth();
    const { userRoles } = useAuth();

    const location = useLocation();

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [users, setAccountData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);

    // Toast state
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    // Function to set the toast
    const handleSetToast = (message, variant) => {
        setToastMessage(message);
        setToastVariant(variant);
        setShowToast(true);
    };

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    // Populate form data when editing

    const viewAccountForAdmin = useCallback((bankId) => {
        setLoading(true);
        showAccountByBankID(bankId)
            .then(response => {
                if (response.status === 200) {
                    const accountData = response.data.map(item => ({
                        id: item.accountId,
                        accountName: item.accountName,
                        status: item.status,
                        invoiceAmount: item.invoiceAmount,
                        paidAmount: item.paidAmount,
                        dueAmount: item.dueAmount,
                        dateOfAllotment: item.dateOfAllotment,
                        npaDate: item.npaDate,
                        amountDemanded132: item.amountDemanded132
                    }));

                    setAccountData(accountData);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching user details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        if (location.state && location.state.bank) {
            const bankId = location.state.bank.bankid;
            setBankName(location.state.bank.bankName + '-' + location.state.bank.branchName);
            viewAccountForAdmin(bankId);
        }
    }, [location.state, viewAccountForAdmin]);
    
    useEffect(() => {
        viewAccountForAdmin();
    }, [viewAccountForAdmin]);

    // Filter users whenever searchTerm or users change
    useEffect(() => {
        const filtered = users.filter(user =>
            Object.values(user).some(value =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredUsers(filtered);
    }, [searchTerm, users]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };


    const handleManagePayment = (accountDetails) => {
        navigate("/payment", { state: { accountDetails: accountDetails } });
    };

    const handleEdit = (accountDetails) => {
        navigate(`/editSarfaesi`, { state: { accountDetails: accountDetails } });
    };

    const conditionalRowStyles = [
        {
            when: (row) => row.dueAmount > 0, // Condition: Due amount greater than 0
            style: {
                backgroundColor: "rgba(255, 0, 0, 0.2)", // Light red background
                color: "red", // Optional: Change text color
            },
        },
    ];

    const formatDate = (date) => {
        if (!date) return ''; // Return empty string if no date is provided
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = String(d.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };


    const columns = [
        {
            name: "Account",
            cell: (row) => (
                <button
                    onClick={() => handleEdit(row)}
                    className="btn btn-sm btn-light"
                    title="Account"
                >
                    {row.accountName}
                </button>
            ),
            sortable: true,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        { name: 'Date of allotment', selector: row => formatDate(row.dateOfAllotment), sortable: true },
        { name: 'NPA Date', selector: row => formatDate(row.npaDate), sortable: true },
        { name: 'Amount demanded as per 13(2)', selector: row => row.amountDemanded132 , sortable: true },
        { name: 'Status', selector: row => row.status || 'New', sortable: true },
        ...(userRoles.includes("ADMIN")
            ? [

                {
                    name: "Invoice Amount",
                    cell: (row) => (
                        <button
                            onClick={() => handleManagePayment(row)}
                            className="btn btn-sm btn-light"
                            title="Invoice Amount"
                        >
                            {row.invoiceAmount}
                        </button>
                    ),
                    sortable: true,
                    sortFunction: (rowA, rowB) =>
                        parseFloat(rowA.invoiceAmount) - parseFloat(rowB.invoiceAmount),
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                },
                {
                    name: "Paid Amount",
                    cell: (row) => (
                        <button
                            onClick={() => handleManagePayment(row)}
                            className="btn btn-sm btn-light"
                            title="Paid Amount"
                        >
                            {row.paidAmount}
                        </button>
                    ),
                    sortable: true,
                    ignoreRowClick: true,
                    sortFunction: (rowA, rowB) =>
                        parseFloat(rowA.paidAmount) - parseFloat(rowB.paidAmount),
                    allowOverflow: true,
                    button: true,
                },
                {
                    name: "Due Amount",
                    cell: (row) => (
                        <button
                            onClick={() => handleManagePayment(row)}
                            className="btn btn-sm btn-light"
                            title="Due Amount"
                        >
                            {row.dueAmount}
                        </button>
                    ),
                    sortable: true,
                    sortFunction: (rowA, rowB) =>
                        parseFloat(rowA.dueAmount) - parseFloat(rowB.dueAmount),
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                },
            ]
            : []),{
            name: "Actions",
            cell: (row) => (
                <>
                    <button
                        onClick={() => handleManagePayment(row)}
                        className="btn btn-sm btn-warning me-1"
                        title="ManagePayment"
                    >
                        <MdPayment />
                    </button>
                    
                </>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }


    ];

    return (
        <div className="ShowUsers">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">{bankName}</h4>
                                <hr className="bg-warning" style={{ height: '4px' }} />
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center">

                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className="form-control me-2"
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                            <button className="btn btn-sm btn-secondary">
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mb-4">
                                    <div className="card-body shadow-sm border-0">
                                        <DataTable
                                            className="data-table"
                                            columns={columns}
                                            data={filteredUsers}
                                            conditionalRowStyles={conditionalRowStyles}
                                            pagination
                                            highlightOnHover
                                        />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>

            <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                className={`custom-toast ${toastVariant}`}
                style={{ position: 'fixed', top: '60px', right: '20px', zIndex: 9999 }}
            >
                <Toast.Body>{toastMessage}
                    setToast={handleSetToast}
                </Toast.Body>
            </Toast>
        </div>
    );
}
